import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cb_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Sessão expirada/inválida: limpa o token e volta para o login em vez de deixar a tela vazia
api.interceptors.response.use((r) => r, (err) => {
  const url = err.config?.url || "";
  if (err.response?.status === 401 && localStorage.getItem("cb_token") && !url.startsWith("/auth/")) {
    localStorage.removeItem("cb_token");
    if (window.location.pathname.startsWith("/app")) window.location.href = "/";
  }
  return Promise.reject(err);
});

export function setToken(t) {
  if (t) localStorage.setItem("cb_token", t);
  else localStorage.removeItem("cb_token");
}

// URL de imagem servida pelo backend (img não envia header, então usa ?auth=token)
export function fileUrl(path) {
  const t = localStorage.getItem("cb_token");
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}?auth=${t}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string"
        ? `${Array.isArray(e.loc) && e.loc.length ? `Campo "${e.loc[e.loc.length - 1]}": ` : ""}${e.msg}`
        : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
